var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", { attrs: { "grid-list-md": "" } }, [
    _c(
      "div",
      [
        _c("div", { staticClass: "holder" }, [
          _c(
            "h2",
            { attrs: { id: "page-header" } },
            [
              _c("router-link", { attrs: { to: "/" } }, [
                _vm._v("My Arlington")
              ]),
              _c("router-link", { attrs: { to: "/polling" } }, [
                _vm._v(" — Polling Place Locator")
              ])
            ],
            1
          ),
          _c("br"),
          _vm._v(" "),
          _c("div", { attrs: { id: "blurb" } }, [
            _c("p", [
              _vm._v(
                "\n               Enter address to find voting location.\n            "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("v-flex", { staticClass: "layer-page" }),
        _vm._v(" "),
        _c("div", { staticClass: "layer-page" }, [
          _c("div", { staticClass: "widget one-third filter-pane" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isMobile || _vm.mobileMenu === false,
                    expression: "isMobile || mobileMenu === false"
                  }
                ],
                staticClass: "filter-header",
                attrs: {
                  type: "button",
                  id: "mobile-menu",
                  "aria-expanded": _vm.mobileMenu ? "true" : "false",
                  "aria-controls": "filters-and-settings"
                },
                on: {
                  click: function($event) {
                    _vm.mobileMenu = !_vm.mobileMenu
                  }
                }
              },
              [
                _vm._v(
                  "\n                  Filters and Location\n                  "
                ),
                _c(
                  "svg",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.mobileMenu,
                        expression: "!mobileMenu"
                      }
                    ],
                    staticClass: "icon",
                    staticStyle: { float: "right" },
                    attrs: { "aria-hidden": "true", focusable: "false" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
                ),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.mobileMenu,
                        expression: "mobileMenu"
                      }
                    ],
                    staticClass: "icon",
                    staticStyle: { float: "right" },
                    attrs: { "aria-hidden": "true", focusable: "false" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isMobile || _vm.mobileMenu,
                    expression: "!isMobile || mobileMenu"
                  }
                ],
                attrs: { id: "filters-and-settings" }
              },
              [
                _c("div", { staticClass: "filter-container" }, [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isMobile,
                          expression: "!isMobile"
                        }
                      ],
                      staticClass: "filter-header",
                      attrs: {
                        type: "button",
                        "aria-expanded": _vm.filtersExpanded ? "true" : "false",
                        "aria-controls": "filters-and-settings"
                      },
                      on: { click: _vm.filtersToggle }
                    },
                    [
                      _c("span", [
                        _vm._v("Filters\n                              "),
                        _c(
                          "svg",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.filtersExpanded,
                                expression: "filtersExpanded"
                              }
                            ],
                            staticClass: "icon",
                            staticStyle: { float: "right" },
                            attrs: { "aria-hidden": "true", focusable: "false" }
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-minus" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.filtersExpanded,
                                expression: "!filtersExpanded"
                              }
                            ],
                            staticClass: "icon",
                            staticStyle: { float: "right" },
                            attrs: { "aria-hidden": "true", focusable: "false" }
                          },
                          [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
                        ),
                        _vm._v(" "),
                        _c("span", {
                          staticStyle: { clear: "both", display: "block" }
                        })
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-container zoom-container" },
                  [
                    _c("label", { attrs: { for: "addressSearch" } }, [
                      _vm._v("Address")
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("gmap-autocomplete", {
                      ref: "autocomplete",
                      attrs: {
                        id: "addressSearch",
                        placeholder: "Enter street address"
                      },
                      on: { place_changed: _vm.placeChanged }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.voterPrecinctSelected
                  ? _c(
                      "div",
                      { staticClass: "filter-container zoom-container" },
                      [
                        _c(
                          "h3",
                          [
                            _vm.voterPrecinctSelected.PREC_NAME ||
                            _vm.voterPrecinctSelected.POLLING_PLACE
                              ? [
                                  _vm._v(
                                    _vm._s(_vm.voterPrecinctSelected.PREC_NAME)
                                  ),
                                  _vm.voterPrecinctSelected.PREC_NAME &&
                                  _vm.voterPrecinctSelected.POLLING_PLACE
                                    ? _c("span", [_vm._v(" - ")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(
                                      _vm.voterPrecinctSelected.POLLING_PLACE
                                    )
                                  )
                                ]
                              : [_vm._v("Polling place")]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(_vm.voterPrecinctSelected.ADDRESS))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "widget full-map-pane toggle-window" },
            [
              _c("div", { staticStyle: { position: "relative", top: "0" } }, [
                _c(
                  "div",
                  {
                    staticClass: "toggle-bar",
                    attrs: { role: "group", "aria-label": "Map or list" }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "toggle-link active",
                        attrs: {
                          type: "button",
                          "aria-pressed": _vm.showMap === true
                        },
                        on: {
                          click: function($event) {
                            _vm.showMap = true
                          }
                        }
                      },
                      [_vm._v("Map")]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "gmap-map",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showMap,
                      expression: "showMap"
                    }
                  ],
                  attrs: {
                    center: _vm.mapCenter,
                    zoom: _vm.zoomLevel,
                    options: _vm.mapStyles,
                    id: "vue-map-container",
                    "aria-label": "Map of polling place for your address"
                  }
                },
                [
                  _vm.selectedCoordinates && !_vm.selectedCoordinates.fac
                    ? _c("gmap-marker", {
                        attrs: { position: _vm.selectedCoordinates, radius: 24 }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.voterPrecinctSelected
                    ? _c("gmap-polygon", {
                        attrs: {
                          path: _vm.voterPrecinctSelected.paths,
                          options: _vm.locationOptions
                        },
                        on: {
                          click: function(e) {
                            return _vm.infoClick(_vm.voterPrecinctSelected, e)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedCoordinates && _vm.radiusSelected
                    ? _c("GmapCircle", {
                        attrs: {
                          center: _vm.selectedCoordinates,
                          radius: _vm.radiusSelected * 1609,
                          visible: true,
                          options: {
                            fillColor: "blue",
                            fillOpacity: 0.1,
                            strokeWeight: 0.7,
                            strokeColor: "blue"
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "gmap-info-window",
                    {
                      attrs: {
                        opened: _vm.selectedInfoWindowPosition !== null,
                        position: _vm.selectedInfoWindowPosition
                      },
                      on: { closeclick: _vm.infoWindowCloseClick }
                    },
                    [
                      _c("h3", { staticClass: "info-window-header" }, [
                        _vm.selectedItem.PREC_NAME ||
                        _vm.selectedItem.POLLING_PLACE
                          ? _c("b", [
                              _vm._v(_vm._s(_vm.selectedItem.PREC_NAME)),
                              _vm.selectedItem.PREC_NAME &&
                              _vm.selectedItem.POLLING_PLACE
                                ? _c("span", [_vm._v(" - ")])
                                : _vm._e(),
                              _vm._v(_vm._s(_vm.selectedItem.POLLING_PLACE))
                            ])
                          : _c("b", [_vm._v("Polling place")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-window-body" }, [
                        _vm._v(
                          "\n                          " +
                            _vm._s(_vm.selectedItem.ADDRESS) +
                            "\n                        "
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f91a1206", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f91a1206","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pollingPlaces/polling.vue
// module id = zMJp
// module chunks = 1